import { QueryClient, useQuery, useQueryClient } from "react-query";
import { firestore } from "@/services/firestore";

const invalidateTotalUsersQuery = (queryClient: QueryClient) => {
  // This function can be used to invalidate the total users query
  // when a user is added or removed, ensuring the data is fresh.
  queryClient.invalidateQueries("totalUsers");
};

const totalUsersQuery = () => ({
  queryKey: ["totalUsers"],
  queryFn: async () => {
    // This function should return the total number of users.
    return await firestore.getDocumentCount("/users");
  },
  refetchOnWindowFocus: false,
});

export const useTotalUsersQuery = () => {
  return useQuery(totalUsersQuery());
};

export const useInvalidateTotalUsersQuery = () => {
  const queryClient = useQueryClient();
  return () => invalidateTotalUsersQuery(queryClient);
};
